import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    LaneGroupTemperatureRange, IncoTerm, LocationType,
} from 'app/enums/label.enums'

import {
    LongTermLeaseType,
} from '../../../longTermLease.types'

const getFields = (
    getAllowedValues: (param: Record<string, string>) => Record<string, string>,
    exists: boolean,
): DTOCardFormField<keyof LongTermLeaseType>[] => {
    return [{
        title: 'Contract Details',
        className: 'contractDetails',
        id: 'contractDetails',
        fields: [
            {
                id: 'contractDetailsColumn1',
                fields: [
                    {
                        name: 'customerReference',
                        componentName: 'InputSingleline',
                        labelKey: 'Order.customerReference',
                    },
                    {
                        name: 'receivedOn',
                        componentName: 'DateTimeZonedSelect',
                        required: true,
                        labelKey: 'LongTermLeaseForm.receivedOn',
                    },
                    {
                        name: 'enteredOn',
                        componentName: 'DateTimeZonedSelect',
                        labelKey: 'LongTermLeaseForm.enteredOn',
                    },
                    {
                        name: 'tempRange',
                        componentName: 'MultiEnumSelector',
                        allowedValues: getAllowedValues(LaneGroupTemperatureRange),
                        disabled: exists,
                        labelKey: 'LaneGroup.tempRange',
                    },
                    {
                        name: 'incoTerm',
                        componentName: 'Select',
                        allowedValues: getAllowedValues(IncoTerm),
                        labelKey: 'LaneOpsInformationDto.incoTerm',
                    },
                ],
            },
            {
                id: 'contractDetailsColumn2',
                fields: [
                    {
                        name: 'incoTermLocation',
                        componentName: 'LocationObjectSelector',
                        filterLocationType: LocationType.AIRPORT,
                        required: true,
                        labelKey: 'LaneOpsInformationDto.incoTermLocation',
                    },
                    {
                        name: 'leaseStartTimestamp',
                        componentName: 'DateTimeZonedSelect',
                        required: true,
                        labelKey: 'OrderBilling.leaseStartTimestamp',
                    },
                    {
                        name: 'leaseEndTimestamp',
                        componentName: 'DateTimeZonedSelect',
                        labelKey: 'OrderBilling.leaseEndTimestamp',
                    },
                    {
                        name: 'commentForBillingOps',
                        componentName: 'LongText',
                        labelKey: 'OrderByNumberView.commentForBillingOps',
                    },
                ],
            },
        ],
    }]
}

export default getFields
